import { api } from "@/lib/api";

export type OverviewState = "kriticno" | "uskoro" | "nedostaje" | "ok" | "nema_podataka";
export interface OverviewItem {
  naziv: string;
  stanje: OverviewState;
  rok: string | null;
  dana_do: number | null;
  opis: string | null;
  tab_za_akciju: string;
}
export interface OverviewSection {
  kljuc: string;
  naziv: string;
  stanje: OverviewState;
  stavke: OverviewItem[];
  opis: string | null;
}
export interface CurrentAssignment {
  id: string;
  gradiliste_id: string;
  gradiliste: string;
  vrijedi_od: string;
  vrijedi_do: string | null;
  brigada_id: string | null;
  brigada: string | null;
}
export interface MissingWorkerField { polje: string; naziv: string; sekcija: string }
export interface WorkerOverview {
  status_radnika: { stanje: "aktivan" | "bivsi" | "povijesni"; datum_prestanka: string | null; razlog: string | null };
  trenutni_raspored: CurrentAssignment | null;
  sekcije: OverviewSection[];
  akcije: OverviewItem[];
  brojaci: Record<OverviewState, number>;
  nedostajuca_polja: MissingWorkerField[];
}
export async function fetchWorkerOverview(workerId: string, signal?: AbortSignal): Promise<WorkerOverview> {
  const data = (await api.get<WorkerOverview>(`/radnici/${workerId}/pregled`, { signal })).data;
  if (!Array.isArray(data.sekcije) || !Array.isArray(data.akcije) || !data.status_radnika) throw new Error("Pregled nije dostupan. Pokušajte ponovno.");
  return data;
}
